module.exports = __webpack_public_path__ + "static/media/Illus-PlateEmpty@2x.ad56eea6.png";